<template>
  <span class="stopwatch" :class="modifiers">
    {{ text }}
  </span>
</template>

<script>
export default {
  name: 'BaseStopwatch',
  props: {
    hasIndicator: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      onPause: false,
      isRunning: false,
      seconds: 0,
    };
  },
  staticData: () => ({
    timestamp: null,
    lastTimestamp: null,
    pauseTimestamp: null,
    raf: null,
  }),
  computed: {
    text() {
      if (this.seconds === 0) {
        return '00:00';
      }
      const minutes = String(Math.floor(this.seconds / 60)).padStart(2, '0');
      const seconds = String(Math.floor(this.seconds % 60)).padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
    modifiers() {
      return {
        stopwatch_has_indicator: this.hasIndicator,
        stopwatch_running: this.isRunning,
        stopwatch_pause: this.onPause,
      };
    },
  },
  beforeDestroy() {
    window.cancelAnimationFrame(this.raf);
  },
  methods: {
    start() {
      if (this.isRunning) return;
      this.isRunning = true;
      this.timestamp = null;
      this.seconds = 0;
      this.raf = window.requestAnimationFrame(this.calculate);
      this.$emit('start');
    },
    stop() {
      this.isRunning = false;
      this.timestamp = null;
      this.seconds = 0;
      this.$emit('stop');
    },
    pause() {
      if (this.onPause) return;
      const diffTimestamp = this.lastTimestamp - this.timestamp;
      this.onPause = true;
      this.isRunning = false;
      this.pauseTimestamp = performance.now() - this.lastTimestamp + diffTimestamp;
      this.timestamp = null;
      this.$emit('pause');
    },
    resume() {
      this.onPause = false;
      this.isRunning = true;
      this.timestamp = performance.now() - this.pauseTimestamp;
      this.pauseTimestamp = null;
      this.raf = window.requestAnimationFrame(this.calculate);
      this.$emit('resume');
    },
    calculate(timestamp) {
      if (!this.isRunning) return;

      if (!this.timestamp) {
        this.timestamp = timestamp;
      }

      const diff = (timestamp - this.timestamp) / 10;

      if (diff >= 100) {
        this.seconds += 1;
        this.timestamp = timestamp;
      }

      this.lastTimestamp = timestamp;
      this.raf = window.requestAnimationFrame(this.calculate);
    },
    setSeconds(seconds) {
      this.seconds = seconds;
      this.timestamp = null;
    },
  },
};
</script>

<style lang="stylus">
.stopwatch
  display inline-block
  vertical-align middle
  white-space nowrap
  text-align left
  width 2.4em

  &_has_indicator
    width 3.4em
    &:before
      content '\25CF'
      display inline-block
      vertical-align middle
      font-size 0.7em
      margin-right 0.25em
      margin-top -0.1em
      color $c_error
</style>
